import { Component, Input, HostBinding } from '@angular/core';

/**
 * can be used like this:
 * <ds-icon-card text= "text" [routerLink]="[...]" [disabled]="true" (click)="...">
 * search
 * </ds-icon-card>
 */
@Component({
  selector: 'ds-lib-icon-card',
  templateUrl: './ds-lib-icon-card.component.html',
  styleUrls: ['./ds-lib-icon-card.component.scss'],
})
export class DsLibIconCardComponent {
  /**
   * adds the class .disabled on the :host if true. Removes it if false.
   */
  @HostBinding('class.disabled') disabledClass = false;

  /**
   * Text displayed below the icon
   */
  @Input() text = '';

  /**
   * If the desired icon is not a standard material icon, set the name here. Same behavior as the <mat-icon> element.
   */
  @Input() svgIcon = null;

  /**
   * disabled property.
   */
  isDisabled = false;

  /**
   * Setter activated when setting the [disabled] property.
   *
   * @param value the disabled state
   */
  @Input() set disabled(value: boolean) {
    this.isDisabled = value;
    this.disabledClass = this.isDisabled;
  }
}
